export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/ro.39b0ebb6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};